<!--
 * @Author: rossdong@yntengyun.com
 * @Date: 2024-10-14 17:28:52
 * @Description:  A 考核项头部
-->
<template>
  <div class="bg-white pt-23">
    <div class="head pb-16 px-12">
      <div class="title">
        <div class="text">{{ data.monitorTypeCN }}</div>
        <div class="righttext" v-if="(data.submited === 1 && data.audited === 0) || data.deduction == 0">
          <div class="no-de">未扣分</div>
        </div>
        <div class="righttext" v-else>
          <div class="branch">-{{ (data.deduction || 0) / 100 }}</div>
        </div>
      </div>
      <div class="text-12 text-[#999999]">{{ data.areaName }} {{ data.monitorDate }}</div>
    </div>
    
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  name: 'AHeader',
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    // 这里存放数据
    return {
      title: '',

    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {

  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() { }, // 生命周期 - 创建之前
  beforeMount() { }, // 生命周期 - 挂载之前
  beforeUpdate() { }, // 生命周期 - 更新之前
  updated() { }, // 生命周期 - 更新之后
  beforeDestroy() { }, // 生命周期 - 销毁之前
  destroyed() { }, // 生命周期 - 销毁完成
  activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>


<style lang="less" scoped>
.head {
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #eee;

  .title {
    line-height: 20px;
    display: flex;
    justify-content: space-between;
    min-height: 42.98px;

    .righttext {
      text-align: right;
    }

    .isaudied {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 140, 25, 1);
      line-height: 28px;
    }

    .text {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      line-height: 28px;
      padding-right: 50px;
    }

    .score-div {
      font-size: 14px;
      font-family: DIN-Medium, DIN;
      font-weight: 500;
      color: rgba(153, 153, 153, 1);
      line-height: 14px;
      margin-top: 8px;
    }

    .branch {
      height: 22px;
      font-size: 22px;
      font-family: DIN-Medium, DIN;
      font-weight: 500;
      color: rgba(255, 77, 77, 1);
      line-height: 28px;
    }

    .no-de {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #999;
      line-height: 22px;
    }
  }
}
</style>